import { createModalStore } from '@/shared/lib/modal';

export const useTeamspaceSettingsModal = createModalStore();
